module.exports = __webpack_public_path__ + "static/media/twittericon.37bc18d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/socialIcons/twittericon.png
// module id = 1213
// module chunks = 0